export default __webpack_public_path__ + "static/media/yeti.3e573295.png";